import { UseFormReturn } from 'react-hook-form';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import { CommodityItemCard } from '../components/CommodityItemCard';
import { TransportProFormLoad } from '../types';

type ItemsSectionProps = {
  formMethods: UseFormReturn<TransportProFormLoad>;
};

export function ItemsSection({ formMethods }: ItemsSectionProps) {
  const commodities = formMethods.watch('commodities') ?? [];

  if (commodities.length === 0) {
    return (
      <Typography variant='body-sm' className='text-neutral-500'>
        No items on this load.
      </Typography>
    );
  }

  return (
    <Flex direction='col' gap='md' className='w-full'>
      {commodities.map((item, index) => (
        <CommodityItemCard
          key={item.ID ?? `commodity-${index}`}
          index={index}
          formMethods={formMethods}
        />
      ))}
      <Typography variant='body-sm' className='text-neutral-600'>
        Total items: {commodities.length}
      </Typography>
    </Flex>
  );
}
